import React from 'react';

export default function BulkActionsBar({
  selectedCount,
  onClear,
  onSelectAll,
  onDelete,
  selectAllLabel = 'Seleccionar visibles',
  deleteLabel = 'Eliminar seleccionados',
  disabled = false,
}) {
  if (!selectedCount) return null;

  return (
    <div className="bg-white p-4 rounded-lg shadow border border-gray-200">
      <div className="flex flex-col gap-3 max-lg:items-stretch lg:flex-row lg:items-center lg:justify-between">
        <div className="shrink-0 whitespace-nowrap text-sm font-medium text-gray-700 tabular-nums max-lg:w-full max-lg:text-center lg:text-left">
          {selectedCount} seleccionado{selectedCount === 1 ? '' : 's'}
        </div>
        <div className="flex flex-wrap items-center gap-2 max-lg:portrait:grid max-lg:portrait:w-full max-lg:portrait:grid-cols-1 max-lg:portrait:gap-2">
          {onSelectAll ? (
            <button
              type="button"
              onClick={onSelectAll}
              className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 text-sm font-semibold hover:bg-gray-200 transition-colors max-lg:portrait:w-full max-lg:portrait:py-2.5 max-lg:portrait:text-center"
            >
              {selectAllLabel}
            </button>
          ) : null}
          <button
            type="button"
            onClick={onClear}
            className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 text-sm font-semibold hover:bg-gray-200 transition-colors max-lg:portrait:w-full max-lg:portrait:py-2.5 max-lg:portrait:text-center"
          >
            Limpiar selección
          </button>
          <button
            type="button"
            disabled={disabled}
            onClick={onDelete}
            className="px-4 py-2 rounded-lg bg-red-600 text-white text-sm font-semibold hover:bg-red-700 disabled:opacity-60 disabled:cursor-not-allowed transition-colors max-lg:portrait:w-full max-lg:portrait:py-2.5 max-lg:portrait:text-center"
          >
            {deleteLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
